import { createAsyncThunk } from '@reduxjs/toolkit';
import { DownloadTermDepositsPayload, fetchExpiringTermDepositPayload, fetchPagedResults, TermDepositList } from '../types';
import api from 'src/app/api';
import { convertToCSVFormat, CSVDataType, downloadCsv } from 'src/common/utils/fileDownload';

export enum ExpiringTermDepositsListActionTypes {
  FetchExpiringTermDepositslList = '@@termDeposit/list/FetchExpiringTermDepositslList',
  DownloadTermDeposits = '@@client/termDeposit/downloadTermDeposits',
}

export enum ExpiringTermDepositsApiEndpoints {
  fetchExpiringTermDepositslList = '/bff/GetTermDeposits',
}

export const fetchExpiringTermDeposit = createAsyncThunk<
  fetchPagedResults<TermDepositList>,     
  fetchExpiringTermDepositPayload>(
  ExpiringTermDepositsListActionTypes.FetchExpiringTermDepositslList,
  async (wrapper) => {

    const response = await api.post<fetchPagedResults<TermDepositList>>(
      ExpiringTermDepositsApiEndpoints.fetchExpiringTermDepositslList,
      {
        clientIds: wrapper.clientIds,
        asAtDate: wrapper.AsAtDate,
        pagedRequest: wrapper.PagedRequest,
        clientNameSearch: wrapper.clientNameSearch,
        queryFields: wrapper.queryFields
      }
    );

    return response.data; 
  }
);

export const downloadTermDeposits = createAsyncThunk(
  ExpiringTermDepositsListActionTypes.DownloadTermDeposits,
  async (wrapper: DownloadTermDepositsPayload) => {

    const response = await api.post(
      ExpiringTermDepositsApiEndpoints.fetchExpiringTermDepositslList,
      {
        clientIds: wrapper.clientIds,
        asAtDate: wrapper.asAtDate,
        pagedRequest: {
          ...wrapper.pagination,
          pageNumber: 1,
          pageSize: 9999999,
        },
        clientNameSearch: wrapper.clientNameSearch,
        queryFields: wrapper.queryFields,
      }
    );

    const data: CSVDataType[] = convertToCSVFormat(response.data.results, true);
    const headerMapping = {
        clientName: "CLIENT NAME",
        portfolioName: "PORTFOLIO NAME",
        adviserName: "ADVISER NAME",
        securityType: "SECURITY TYPE",
        afslName: "AFSL NAME",
        securityCode: "SECURITY CODE",
        value: "VALUE",
        interestRate: "INTEREST RATE",
        term: "TERM",
        commencementDate: "COMMENCEMENT DATE",
        maturityDate: "MATURITY DATE",
      } as const;
  
      const reorderedData = data.map((row) => {
        const newRow: CSVDataType = {};
        for (const key in headerMapping) {
          const typedKey = key as keyof typeof headerMapping; 
          const label = headerMapping[typedKey];
          newRow[label] = row[typedKey] ?? "";
        }
        return newRow;
      });

    downloadCsv(reorderedData, "Expiring_Term_Deposits_");

    return { message: "CSV downloaded" };
  }
);
